import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {WholesalerIntegrationStepsEnum} from '../../../interfaces/WholesalerIntegrationStepsEnum';
import {IWholesalerConnection} from '../../../../shared/interfaces/wholesaler-integration.interface';
import {fadeInOut} from '../../../../shared/animations/animations';
import { Store } from '@ngxs/store';
import { GetWholesalersList } from 'src/app/shared/states/profile/profile.actions';

@Component({
  selector: 'app-wholesaler-integration-dialog',
  templateUrl: './wholesaler-integration-dialog.component.html',
  styleUrls: ['./wholesaler-integration-dialog.component.scss'],
  animations: [fadeInOut],
})
export class WholesalerIntegrationDialogComponent implements OnInit {
  @Input() show: boolean;
  @Input() wholesalerIntegration: IWholesalerConnection | undefined;
  @Input() progress: WholesalerIntegrationStepsEnum;

  @Output() cancel: EventEmitter<void> = new EventEmitter();
  @Output() nextStep: EventEmitter<WholesalerIntegrationStepsEnum> = new EventEmitter();
  @Output() save: EventEmitter<any> = new EventEmitter();

  WholesalerIntegrationStepsEnum = WholesalerIntegrationStepsEnum;

  constructor(private store: Store) {
  }

  ngOnInit(): void {
    this.store.dispatch(new GetWholesalersList());
    if (this.wholesalerIntegration) {
      setTimeout(() => this.setNextStep(WholesalerIntegrationStepsEnum.PendingConnection));
    }
  }

  setNextStep(step: WholesalerIntegrationStepsEnum | null): void {
    if (!step) {
      this.cancel.emit();
      return;
    }

    this.progress = step;
    this.nextStep.emit(step);
  }
}
